import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { View } from '../../atoms/View'

import Cross from '../Cross'
import CrossWrapper from './CrossWrapper'
import _Link from '../Link'

const Container = styled(View)`
  border-radius: 24px;
  border: solid 0.5px #d2d2d2;
  padding-left: var(--spacing-5);
  padding-right: var(--spacing-5);
  padding-top: var(--spacing-1);
  padding-bottom: var(--spacing-1);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-2);
  text-align: center;
`

const Link = styled(_Link)`
  font-size: 0;
  text-decoration: none;
`

const EmailChip = ({ href, onClick, children, size }) => {
  if (href || onClick) {
    return (
      <Link href={href} onClick={onClick}>
        <Container>
          <span className="typo-body-small">{children}</span>
          <CrossWrapper>
            <Cross href={href} onClick={onClick} />
          </CrossWrapper>
        </Container>
      </Link>
    )
  }
  return (
    <Container>
      <span className="typo-body-small">{children}</span>
    </Container>
  )
}

EmailChip.defaultProps = {
  size: 'body1',
}

EmailChip.propTypes = {
  href: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node,
  size: PropTypes.string,
}

export default EmailChip
